(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-showcase"] && !Shopify.designMode) return;
  try {
    
  class CollectionsShowcase {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-collections-track]');
      this.prevButton = section.querySelector('.collections-showcase__arrow--prev');
      this.nextButton = section.querySelector('.collections-showcase__arrow--next');
      this.currentIndex = 0;
      this.totalItems = this.track.children.length;
      this.scrollAmount = 1;

      this.init();
    }

    init() {
      if (this.prevButton && this.nextButton) {
        this.prevButton.addEventListener('click', () => this.prev());
        this.nextButton.addEventListener('click', () => this.next());
      }

      window.addEventListener('resize', () => {
        this.currentIndex = 0;
        this.updateTrack();
      });

      this.updateButtons();
    }

    getItemsPerView() {
      if (window.innerWidth <= 1024) return 1;
      return 3;
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex = Math.max(0, this.currentIndex - this.scrollAmount);
        this.updateTrack();
      }
    }

    next() {
      const itemsPerView = this.getItemsPerView();
      const maxIndex = Math.max(0, this.totalItems - itemsPerView);
      if (this.currentIndex < maxIndex) {
        this.currentIndex = Math.min(maxIndex, this.currentIndex + this.scrollAmount);
        this.updateTrack();
      }
    }

    updateTrack() {
      const items = this.track.children;
      if (items.length === 0) return;

      const itemsPerView = this.getItemsPerView();
      
      if (window.innerWidth <= 1024) {
        const itemWidth = 330 + 16;
        this.track.style.transform = `translateX(-${this.currentIndex * itemWidth}px)`;
      } else {
        const itemWidth = items[0].offsetWidth + 16;
        this.track.style.transform = `translateX(-${this.currentIndex * itemWidth}px)`;
      }

      this.updateButtons();
    }

    updateButtons() {
      if (this.prevButton && this.nextButton) {
        const itemsPerView = this.getItemsPerView();
        const maxIndex = Math.max(0, this.totalItems - itemsPerView);
        
        const hideArrows = this.totalItems <= itemsPerView;

        this.prevButton.disabled = this.currentIndex === 0;
        this.nextButton.disabled = this.currentIndex >= maxIndex;

        this.prevButton.classList.toggle('is-hidden', hideArrows);
        this.nextButton.classList.toggle('is-hidden', hideArrows);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.collections-showcase');
    sections.forEach(section => new CollectionsShowcase(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const accordionTriggers = document.querySelectorAll('.footer-main__menu-accordion-trigger');

accordionTriggers.forEach(function(trigger) {
trigger.addEventListener('click', function() {
const isExpanded = this.getAttribute('aria-expanded') === 'true';
const content = this.nextElementSibling;

// Close all other accordions
accordionTriggers.forEach(function(otherTrigger) {
if (otherTrigger !== trigger) {
otherTrigger.setAttribute('aria-expanded', 'false');
otherTrigger.nextElementSibling.style.maxHeight = null;
}
});

// Toggle current accordion
this.setAttribute('aria-expanded', !isExpanded);

if (!isExpanded) {
content.style.maxHeight = content.scrollHeight + 'px';
} else {
content.style.maxHeight = null;
}
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
